import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function initHero(el) {
  if (el.dataset.wvAnimInited === "1") return;
  el.dataset.wvAnimInited = "1";

  const title = el.querySelector(".hero-title");
  const desc = el.querySelector(".hero-description");
  const btn = el.querySelector(".hero-button");
  const overlay = el.querySelector(".wv-image-overlay");

  const items = [title, desc, btn].filter(Boolean);

  gsap.set(items, { autoAlpha: 0, y: 24 });
  if (overlay) gsap.set(overlay, { autoAlpha: 0 });

  const tl = gsap.timeline({
    defaults: { duration: 0.8, ease: "power3.out" },
    scrollTrigger: {
      trigger: el,
      start: "top 75%",
      once: true,
    },
  });

  if (overlay) {
    tl.to(overlay, { autoAlpha: 1, duration: 0.6 }, 0);
  }

  tl.to(items, { autoAlpha: 1, y: 0, stagger: 0.18 }, 0.1);
}

function initAll() {
  document.querySelectorAll('[data-wv-hero]').forEach(initHero);
  ScrollTrigger.refresh();
}

// единая точка входа
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initAll);
} else {
  initAll();
}